import { Text } from '@querodelivery/uni-react';
import type { ReactNode } from 'react';

interface MetricValueProps {
  children: ReactNode;
}

export function MetricValue({ children }: MetricValueProps) {
  return (
    <Text as="span" fontSize="md" fontWeight="semibold" lineHeight="lg">
      {children}
    </Text>
  );
}
